<template>
  <d-modal
    @close="handleClose"
    size="lg">
    <d-modal-header>
      <d-modal-title>
        Zadania pracownika: <span class="text-primary">{{ workerName }}</span>
      </d-modal-title>
    </d-modal-header>
    <d-modal-body class="p-0">
      <table class="table table-bordered table-sm w-100 mb-0">
        <thead>
          <tr>
            <th style="min-width: calc(50% - 280px);" class="pl-3">Produkt</th>
            <th style="min-width: calc(50% - 280px);">Zamówienie</th>
            <th style="min-width: 160px;">Termin</th>
            <th style="min-width: 120px;">Postęp</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) of performance"
            :key="'performance-item-' + index">
            <td class="pl-3">{{ item.product_name }}</td>
            <td>{{ item.order_name }}</td>
            <td><small>{{ item.start_at }} - {{ item.end_at }}</small></td>
            <td>
              <small :class="{ 'text-success': item.quantity_done >= item.quantity, 'text-danger': item.quantity_done < item.quantity }">
                {{ item.quantity_done }} szt.
              </small>
              <small>/</small>
              <small> {{ item.quantity }} szt.</small>
            </td>
          </tr>
        </tbody>
      </table>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-auto mr-auto"
        theme="danger"
        @click.prevent="handleClose">
        Zamknij
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
export default {
  name: 'order-worker-performance-popup',
  props: [
    'performance',
    'workerName'
  ],
  methods: {
    handleClose () {
      this.$bus.$emit('order-hide-worker-performance-popup');
    }
  }
}
</script>
